import { Container, Card, Text, VStack } from "@chakra-ui/react"
import React from 'react'

export default function CancellationAndRefund() {
    return (
        <Container maxW='8xl' my='6'>
            <VStack w='100%' spacing='4'>
                <Card p='5' w='100%'>
                    <Text fontSize='2xl' fontWeight='800' className='customfont'>Cancellation And Refund</Text>
                </Card>
                <Card p='5' w='100%'>
                    <Text>M/S SHARDA PRINTERS believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:</Text>

                    <Text>Cancellations will be considered only if the request is made within 7 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.</Text>

                    <Text>M/S SHARDA PRINTERS does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.</Text>

                    <Text>In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 7 days of receipt of the products.</Text>

                    <Text>In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 7 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.</Text>

                    <Text>In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.</Text>

                    <Text>In case of any Refunds approved by the M/S SHARDA PRINTERS, it'll take 6-8 days for the refund to be processed to the end customer.</Text>
                </Card>
            </VStack>
        </Container>

    )
}
